module.exports = __webpack_public_path__ + "img/actic.9eba5b26.svg";